/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnChanges, type OnInit, Component, Injector, Input } from '@angular/core';
import { type ColumnDef, type TableConfig, I18nService, TableAbstract, UNPLACEHOLDER, UtilService } from '@dm/core';
import { type Port } from 'app/common/types/mo';
import { FeatureConfig } from 'app/config/feature';
import { PortGroupMemberTypeE } from 'app/feature/service/block-service/port-group/port-group.const';
import { PortGroupStrService } from 'app/feature/service/block-service/port-group/port-group-str.service';

@Component({
    selector: 'app-member-port-table',
    templateUrl: './member-port-table.component.html',
})
export class MemberPortTableComponent extends TableAbstract<Port> implements OnInit, OnChanges {
    @Input() data: Port[] = [];
    // 成员端口类型
    @Input() portGroupMemberType;
    @Input() loading = false;
    // 表格行配置对象
    tableColumnDefs: ColumnDef[];
    // 表格总配置对象
    tableConfig: TableConfig;

    constructor(
        private i18n: I18nService,
        public str: PortGroupStrService,
        injector: Injector,
        private utilService: UtilService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
    }

    ngOnChanges(): void {
        this.initTable();
    }

    initBtns(): void {
    }

    initTable(): void {
        // 物理端口
        const phyColumnDefs: ColumnDef[] = [
            {
                field: 'newType',
                header: this.i18n.get('common.type_column'),
                filterType: 'dropdown',
                options: this.str.portObj,
                render: (value, col, data) => col.options[data.newType],
                sortable: true,
            },
            {
                field: 'LOCATION',
                header: this.i18n.get('common.location_column'),
                sortable: true,
                filterType: 'search',

            },
            {
                field: 'HEALTHSTATUS',
                header: this.i18n.get('common.healthStatus_column'),
                options: this.str.portHealthStatusObj,
                render: (data, col) => col.options[data],
                sortable: true,
            },
            {
                field: 'RUNNINGSTATUS',
                header: this.i18n.get('common.runningStatus_column'),
                options: this.str.portRunningStatusObj,
                sortable: true,
                render: (data, col) => col.options[data],
            },
            {
                field: 'WWN',
                header: this.i18n.get('common.WWPN_lab'),
                render: (value: string) => value || UNPLACEHOLDER,
                columnFilter: FeatureConfig.IsSupportFC,
                hidden: !FeatureConfig.IsSupportFC,
            },
        ];

        // 逻辑端口
        const lifColumnDefs: ColumnDef[] = [
            {
                field: 'NAME',
                header: this.i18n.get('common.name_column'),
                filterType: 'search',
            },
            {
                field: 'SUPPORTPROTOCOL',
                header: this.i18n.get('system.logicPort_task_create_dataProtocol_label'),
                columnFilter: true,
                filterType: 'dropdown',
                options: this.str.lifProtocolOptions,
                render: (value: string) => this.utilService.getLabelFromOptions(this.str.lifProtocolOptions, Number(value)),
            },
            {
                field: 'OPERATIONALSTATUS',
                header: this.i18n.get('protection.vstore_hyperMetroDomain_task_view_activeStatus_lab'),
                columnFilter: true,
                filterType: 'dropdown',
                options: this.str.lifActiveOptions,
                render: (value: string) => this.str.lifActiveOpt[value] || UNPLACEHOLDER,
            },
            {
                field: 'RUNNINGSTATUS',
                header: this.i18n.get('common.runningStatus_column'),
                options: this.str.lifPortRunningStatusOpt,
                sortable: true,
                render: (data, col) => col.options[data],
                columnFilter: true,
            },
        ];

        this.tableColumnDefs = this.portGroupMemberType === PortGroupMemberTypeE.Lif ? lifColumnDefs : phyColumnDefs;

        this.tableConfig = {
            dataKey: 'ID',
            motion: false,
            rows: 5,
        };
    }
}
